import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { onlyNumberWithDecimal, fmtMoney } from '../../../components/functions'
import { useEnergiaEletricaCompradaContext } from '../../../context/energiaCompradaContext'
import CurrencyInput from '../../../components/CurrencyInput'
import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {

    const energia_id = props.energia_id
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    

    const tipoEnergia = 'comprada'

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()
    const { energiaEletricaComprada_id, setEnergiaEletricaComprada_id } = useEnergiaEletricaCompradaContext()

    const [tipoConsumidor, setTipoConsumidor] = useState('')
    const [descricaoFatura, setDescricaoFatura] = useState('')
    const [concessionaria, setConcessionaria] = useState('')
    const [percDescontoTSUD, setPercDescontoTSUD] = useState('')
    const [percRenovavel, setPercRenovavel] = useState('')

    const [subgrupoLista, setSubGrupoLista] = useState()
    const [ambienteContratacao, setAmbienteContratacao] = useState()
    const [lista, setLista] = useState([])
    const [subgrupo, setSubGrupo] = useState()


    const [modalidadeTarifariaLista, setModalidadeTariafariaLista] = useState()
    const [modalidadeTarifaria, setModalidadeTarifaria] = useState()
    const [listaMod, setListaMod] = useState([])

    const [resultadoConcessionarias, setResultadoConcessionarias] = useState()



    const [pontaJan, setPontaJan] = useState('')
    const [foraJan, setForaJan] = useState('')    
    const [demJan, setDemJan] = useState('')
    const [demForaJan, setDemForaJan] = useState('')
    const [custoJan, setCustoJan] = useState('')

    const [pontaFev, setPontaFev] = useState('')
    const [foraFev, setForaFev] = useState('')
    const [demFev, setDemFev] = useState('')
    const [demForaFev, setDemForaFev] = useState('')
    const [custoFev, setCustoFev] = useState('')

    const [pontaMar, setPontaMar] = useState('')
    const [foraMar, setForaMar] = useState('')
    const [demMar, setDemMar] = useState('')
    const [demForaMar, setDemForaMar] = useState('')    
    const [custoMar, setCustoMar] = useState('')

    const [pontaAbr, setPontaAbr] = useState('')
    const [foraAbr, setForaAbr] = useState('')
    const [demAbr, setDemAbr] = useState('')
    const [demForaAbr, setDemForaAbr] = useState('')
    const [custoAbr, setCustoAbr] = useState('')

    const [pontaMai, setPontaMai] = useState('')
    const [foraMai, setForaMai] = useState('')
    const [demMai, setDemMai] = useState('')
    const [demForaMai, setDemForaMai] = useState('')
    const [custoMai, setCustoMai] = useState('')

    const [pontaJun, setPontaJun] = useState('')
    const [foraJun, setForaJun] = useState('')
    const [demJun, setDemJun] = useState('')
    const [demForaJun, setDemForaJun] = useState('')
    const [custoJun, setCustoJun] = useState('')

    const [pontaJul, setPontaJul] = useState('')
    const [foraJul, setForaJul] = useState('')
    const [demJul, setDemJul] = useState('')
    const [demForaJul, setDemForaJul] = useState('')
    const [custoJul, setCustoJul] = useState('')

    const [pontaAgo, setPontaAgo] = useState('')
    const [foraAgo, setForaAgo] = useState('')
    const [demAgo, setDemAgo] = useState('')
    const [demForaAgo, setDemForaAgo] = useState('')
    const [custoAgo, setCustoAgo] = useState('')

    const [pontaSet, setPontaSet] = useState('')
    const [foraSet, setForaSet] = useState('')
    const [demSet, setDemSet] = useState('')
    const [demForaSet, setDemForaSet] = useState('')
    const [custoSet, setCustoSet] = useState('')

    const [pontaOut, setPontaOut] = useState('')
    const [foraOut, setForaOut] = useState('')
    const [demOut, setDemOut] = useState('')
    const [demForaOut, setDemForaOut] = useState('')
    const [custoOut, setCustoOut] = useState('')

    const [pontaNov, setPontaNov] = useState('')
    const [foraNov, setForaNov] = useState('')
    const [demNov, setDemNov] = useState('')
    const [demForaNov, setDemForaNov] = useState('')
    const [custoNov, setCustoNov] = useState('')

    const [pontaDez, setPontaDez] = useState('')
    const [foraDez, setForaDez] = useState('')
    const [demDez, setDemDez] = useState('')
    const [demForaDez, setDemForaDez] = useState('')
    const [custoDez, setCustoDez] = useState('')




    function consultaDadosCompradaConsumo() {

        if (energiaEletricaComprada_id) {

            api.get(`energiaEletricaCompradaConsumoListaUm/${energiaEletricaComprada_id}`).then((result) => {

                //console.log(result.data)
    
                var data = result.data
    
    
                setPontaJan(data.pontaJan)
                setForaJan(data.foraJan)
    
                setPontaFev(data.pontaFev)
                setForaFev(data.foraFev)
    
                setPontaMar(data.pontaMar)
                setForaMar(data.foraMar)
    
                setPontaAbr(data.pontaAbr)
                setForaAbr(data.foraAbr)
    
                setPontaMai(data.pontaMai)
                setForaMai(data.foraMai)
    
                setPontaJun(data.pontaJun)
                setForaJun(data.foraJun)
    
                setPontaJul(data.pontaJul)
                setForaJul(data.foraJul)
    
                setPontaAgo(data.pontaAgo)
                setForaAgo(data.foraAgo)
    
                setPontaSet(data.pontaSet)
                setForaSet(data.foraSet)
    
                setPontaOut(data.pontaOut)
                setForaOut(data.foraOut)
    
                setPontaNov(data.pontaNov)
                setForaNov(data.foraNov)
    
                setPontaDez(data.pontaDez)
                setForaDez(data.foraDez)
    
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })

        }

        

    }


    function consultaDadosCompradaCusto() {

        if (energiaEletricaComprada_id) {

            api.get(`energiaEletricaCompradaCustoListaUm/${energiaEletricaComprada_id}`).then((result) => {

                //console.log(result.data)

                var data = result.data

                /*
                setCustoJan(data.custoJan ? fmtMoney(data.custoJan, 2) : null)
                setCustoFev(data.custoFev ? fmtMoney(data.custoFev, 2) : null)
                setCustoMar(data.custoMar ? fmtMoney(data.custoMar, 2) : null)
                setCustoAbr(data.custoAbr ? fmtMoney(data.custoAbr, 2) : null)
                setCustoMai(data.custoMai ? fmtMoney(data.custoMai, 2) : null)
                setCustoJun(data.custoJun ? fmtMoney(data.custoJun, 2) : null)
                setCustoJul(data.custoJul ? fmtMoney(data.custoJul, 2) : null)
                setCustoAgo(data.custoAgo ? fmtMoney(data.custoAgo, 2) : null)
                setCustoSet(data.custoSet ? fmtMoney(data.custoSet, 2) : null)
                setCustoOut(data.custoOut ? fmtMoney(data.custoOut, 2) : null)
                setCustoNov(data.custoNov ? fmtMoney(data.custoNov, 2) : null)
                setCustoDez(data.custoDez ? fmtMoney(data.custoDez, 2) : null)
                */

                setCustoJan(data.custoJan !== null && data.custoJan !== undefined ? fmtMoney(data.custoJan, 2) : null)
                setCustoFev(data.custoFev !== null && data.custoFev !== undefined ? fmtMoney(data.custoFev, 2) : null)
                setCustoMar(data.custoMar !== null && data.custoMar !== undefined ? fmtMoney(data.custoMar, 2) : null)
                setCustoAbr(data.custoAbr !== null && data.custoAbr !== undefined ? fmtMoney(data.custoAbr, 2) : null)
                setCustoMai(data.custoMai !== null && data.custoMai !== undefined ? fmtMoney(data.custoMai, 2) : null)
                setCustoJun(data.custoJun !== null && data.custoJun !== undefined ? fmtMoney(data.custoJun, 2) : null)
                setCustoJul(data.custoJul !== null && data.custoJul !== undefined ? fmtMoney(data.custoJul, 2) : null)
                setCustoAgo(data.custoAgo !== null && data.custoAgo !== undefined ? fmtMoney(data.custoAgo, 2) : null)
                setCustoSet(data.custoSet !== null && data.custoSet !== undefined ? fmtMoney(data.custoSet, 2) : null)
                setCustoOut(data.custoOut !== null && data.custoOut !== undefined ? fmtMoney(data.custoOut, 2) : null)
                setCustoNov(data.custoNov !== null && data.custoNov !== undefined ? fmtMoney(data.custoNov, 2) : null)
                setCustoDez(data.custoDez !== null && data.custoDez !== undefined ? fmtMoney(data.custoDez, 2) : null)

            }).catch((err) => {

                console.log(err.response)

            })

        }

        
    }


    function consultaDadosCompradaDemanda() {

        if (energiaEletricaComprada_id) {

            api.get(`energiaEletricaCompradaDemandaListaUm/${energiaEletricaComprada_id}`).then((result) => {

                //console.log(result.data)
                var data = result.data

                setDemJan(data.demJan)
                setDemForaJan(data.demForaJan)

                setDemFev(data.demFev)
                setDemForaFev(data.demForaFev)

                setDemMar(data.demMar)
                setDemForaMar(data.demForaMar)

                setDemAbr(data.demAbr)
                setDemForaAbr(data.demForaAbr)

                setDemMai(data.demMai)
                setDemForaMai(data.demForaMai)

                setDemJun(data.demJun)
                setDemForaJun(data.demForaJun)

                setDemJul(data.demJul)
                setDemForaJul(data.demForaJul)

                setDemAgo(data.demAgo)
                setDemForaAgo(data.demForaAgo)

                setDemSet(data.demSet)
                setDemForaSet(data.demForaSet)

                setDemOut(data.demOut)
                setDemForaOut(data.demForaOut)

                setDemNov(data.demNov)
                setDemForaNov(data.demForaNov)

                setDemDez(data.demDez)
                setDemForaDez(data.demForaDez)



            }).catch((err) => {

                console.log(err.response)

            })

        }

    }



    function carregaConcessionarias() {


        api.get(`energiaEletricaConcessionariaListaTodos`).then((result) => {

            //console.log(result.data)

            setResultadoConcessionarias(result.data.map((rs) =>

                <option value={rs.descricao}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    function consultaDadosCompradaDet() {


        if (energiaEletricaComprada_id) {

            api.get(`energiaEletricaCompradaListaUm/${energiaEletricaComprada_id}`).then((result) => {

                var data = result.data[0]

                //console.log(data, '??')

                setDescricaoFatura(data.descricaoFatura)
                setConcessionaria(data.concessionaria)
                setAmbienteContratacao(data.ambienteContratacao)
                setSubGrupo(data.subgrupo)
                setModalidadeTarifaria(data.modalidadeTarifaria)
                setTipoConsumidor(data.tipoConsumidor)
                setPercDescontoTSUD(data.percDescontoTSUD)
                setPercRenovavel(data.percRenovavel)
                

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }



    function populaSubgrupo() {

        if (ambienteContratacao == 'Regulado') {

            setLista(['A1','A2','A3','A3a','A4','AS','B1','B2','B3','B4'])

        } else {

            if (ambienteContratacao == 'Livre') {

                setLista(['A1','A2','A3','A3a','A4','AS'])

            } else {

                setLista([])

            }

        }

        
        
    }



    function apagaEnergiaComprada() {

        if (energiaEletricaComprada_id) {


            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaEletricaComprada/${energiaEletricaComprada_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow(false)
                            window.$('#modalEnergiaEletricaComprada').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            //consultaDadosComprada()
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }


    }



    function populaModalidadeTarifaria() {

        if (subgrupo == 'A1' || subgrupo == 'A2' || subgrupo == 'A3') {

            setListaMod(['Azul'])

        } else {

            if (subgrupo == 'A3a' || subgrupo == 'A4' || subgrupo == 'AS') {

                setListaMod(['Azul', 'Verde'])

            } else {

                if (subgrupo == 'B1' || subgrupo == 'B2' || subgrupo == 'B3') {

                    setListaMod(['Convencional Monômia', 'Horária Branca'])

                } else {

                    if (subgrupo == 'B4') {

                        setListaMod(['Convencional Monômia'])

                    }

                }
            }

        }

    }




    function salva() {



        if (descricaoFatura == '') {

            //window.toastr.error('<b>Descrição da Fatura</b> não pode ficar em branco!')
            //return false

        }

        



        if (tipoEnergia == 'comprada') {

            if (concessionaria == '') {

                window.toastr.error('<b>Concessionária</b> não pode ficar em branco!')
                return false
    
            }



            if (ambienteContratacao == '') {

                window.toastr.error('<b>Ambiente de Contratação</b> não pode ficar em branco!')
                return false
    
            }
    
    
            if (subgrupo == '') {
    
                window.toastr.error('<b>Subgrupo</b> não pode ficar em branco!')
                return false
    
            }
    
    
            if (modalidadeTarifaria == '') {
    
                window.toastr.error('<b>Modalidade Tarifária</b> não pode ficar em branco!')
                return false
    
            }
    
    

            if (ambienteContratacao == 'Livre') {

                if (tipoConsumidor == '') {

                    window.toastr.error('<b>Tipo de Consumidor</b> não pode ficar em branco!')
                    return false

                }

                /*

                if (percDescontoTSUD == '') {

                    window.toastr.error('<b>% de desconto na TUSD/TUST</b> não pode ficar em branco!')
                    return false

                }

                if (percRenovavel == '') {

                    window.toastr.error('<b>% de energia renovável</b> não pode ficar em branco!')
                    return false

                }

                */
            
            } else {

                //setTipoConsumidor('')
                //setPercDescontoTSUD('')
                //setPercRenovavel('')

            }


            var dataPost = {

                energia_id: energia_id,
                adesao_institucional_id: adesao_institucional_id,
                ano: ano,
                
                tipoEnergia: tipoEnergia,
                
                tipoConsumidor: tipoConsumidor,
                subgrupo: subgrupo,
                ambienteContratacao: ambienteContratacao,
                modalidadeTarifaria: modalidadeTarifaria,
                descricaoFatura: descricaoFatura.toUpperCase(),
                concessionaria: concessionaria,
                percDescontoTSUD: percDescontoTSUD,
                percRenovavel: percRenovavel,

                pontaJan: pontaJan == null ? '' : pontaJan.toString(),
                foraJan: foraJan == null ? '' : foraJan.toString(),    
                demJan: demJan == null ? '' : demJan.toString(),
                demForaJan: demForaJan == null ? '' : demForaJan.toString(),
                custoJan: custoJan == null ? '' : custoJan.toString(),

                pontaFev: pontaFev == null ? '' : pontaFev.toString(),
                foraFev: foraFev == null ? '' : foraFev.toString(),
                demFev: demFev == null ? '' : demFev.toString(),
                demForaFev: demForaFev == null ? '' : demForaFev.toString(),
                custoFev: custoFev == null ? '' : custoFev.toString(),

                pontaMar: pontaMar == null ? '' : pontaMar.toString(),
                foraMar: foraMar == null ? '' : foraMar.toString(),
                demMar: demMar == null ? '' : demMar.toString(),
                demForaMar: demForaMar == null ? '' : demForaMar.toString(),    
                custoMar: custoMar == null ? '' : custoMar.toString(),

                pontaAbr: pontaAbr == null ? '' : pontaAbr.toString(),
                foraAbr: foraAbr == null ? '' : foraAbr.toString(),
                demAbr: demAbr == null ? '' : demAbr.toString(),
                demForaAbr: demForaAbr == null ? '' : demForaAbr.toString(),
                custoAbr: custoAbr == null ? '' : custoAbr.toString(),

                pontaMai: pontaMai == null ? '' : pontaMai.toString(),
                foraMai: foraMai == null ? '' : foraMai.toString(),
                demMai: demMai == null ? '' : demMai.toString(),
                demForaMai: demForaMai == null ? '' : demForaMai.toString(),
                custoMai: custoMai == null ? '' : custoMai.toString(),

                pontaJun: pontaJun == null ? '' : pontaJun.toString(),
                foraJun: foraJun == null ? '' : foraJun.toString(),
                demJun: demJun == null ? '' : demJun.toString(),
                demForaJun: demForaJun == null ? '' : demForaJun.toString(),
                custoJun: custoJun == null ? '' : custoJun.toString(),

                pontaJul: pontaJul == null ? '' : pontaJul.toString(),
                foraJul: foraJul == null ? '' : foraJul.toString(),
                demJul: demJul == null ? '' : demJul.toString(),
                demForaJul: demForaJul == null ? '' : demForaJul.toString(),
                custoJul: custoJul == null ? '' : custoJul.toString(),

                pontaAgo: pontaAgo == null ? '' : pontaAgo.toString(),
                foraAgo: foraAgo == null ? '' : foraAgo.toString(),
                demAgo: demAgo == null ? '' : demAgo.toString(),
                demForaAgo: demForaAgo == null ? '' : demForaAgo.toString(),
                custoAgo: custoAgo == null ? '' : custoAgo.toString(),

                pontaSet: pontaSet == null ? '' : pontaSet.toString(),
                foraSet: foraSet == null ? '' : foraSet.toString(),
                demSet: demSet == null ? '' : demSet.toString(),
                demForaSet: demForaSet == null ? '' : demForaSet.toString(),
                custoSet: custoSet == null ? '' : custoSet.toString(),

                pontaOut: pontaOut == null ? '' : pontaOut.toString(),
                foraOut: foraOut == null ? '' : foraOut.toString(),
                demOut: demOut == null ? '' : demOut.toString(),
                demForaOut: demForaOut == null ? '' : demForaOut.toString(),
                custoOut: custoOut == null ? '' : custoOut.toString(),

                pontaNov: pontaNov == null ? '' : pontaNov.toString(),
                foraNov: foraNov == null ? '' : foraNov.toString(),
                demNov: demNov == null ? '' : demNov.toString(),
                demForaNov: demForaNov == null ? '' : demForaNov.toString(),
                custoNov: custoNov == null ? '' : custoNov.toString(),

                pontaDez: pontaDez == null ? '' : pontaDez.toString(),
                foraDez: foraDez == null ? '' : foraDez.toString(),
                demDez: demDez == null ? '' : demDez.toString(),
                demForaDez: demForaDez == null ? '' : demForaDez.toString(),
                custoDez: custoDez == null ? '' : custoDez.toString(),

                percDescontoTSUD: percDescontoTSUD == null ? '' : percDescontoTSUD.toString(),
                percRenovavel: percRenovavel == null ? '' : percRenovavel.toString(),

                
            }


        }

        

        console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (energiaEletricaComprada_id) {

                        //console.log('aqui')

                        api.put(`energiaEletricaComprada/${energiaEletricaComprada_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            //consultaDadosComprada()
                            //setShow(false)
                            //window.toastr.success('Registro salvo com sucesso!')
                            window.$('#modalEnergiaEletricaComprada').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    } else {

                        api.post(`energiaEletricaComprada`, dataPost).then((result) => {

                            //console.log(result.data)
                            //consultaDadosComprada()
                            //setShow(false)
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalEnergiaEletricaComprada').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                

                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }

    /*
    function consultaDadosComprada() {

        //console.log('!!')

        api.get(`energiaEletricaCompradaListaTodos/${energia_id}`).then((result) => {

            //console.log(result.data)

            setResultadoComprada(result.data.map((rs) =>

                <tr style={{ cursor: 'pointer'}} onClick={() => {setEnergiaEletricaComprada_id(rs.energiaEletricaComprada_id);setShow(true);setTipoEnergia('comprada')}}>
                    <td>
                        {rs.descricaoFatura}
                    </td>
                    <td>
                        {rs.concessionaria}
                    </td>
                    <td>
                        {rs.ambienteContratacao}
                    </td>
                    <td>
                        {rs.subgrupo}
                    </td>
                    <td>
                        {rs.modalidadeTarifaria}
                    </td>
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }
    */


    function limpaCampos() {

        //setEnergiaEletricaComprada_id()
        //setEnergiaEletricaGerada_id()
        setDescricaoFatura('')
        setAmbienteContratacao('')
        setSubGrupo('')
        setModalidadeTarifaria('')

        setTipoConsumidor('')
        setDescricaoFatura('')
        setConcessionaria('')
        setPercDescontoTSUD('')
        setPercRenovavel('')

        

        setPontaJan('')
        setForaJan('')    
        setDemJan('')
        setDemForaJan('')
        setCustoJan('')
        setPontaFev('')
        setForaFev('')
        setDemFev('')
        setDemForaFev('')
        setCustoFev('')

        setPontaMar('')
        setForaMar('')
        setDemMar('')
        setDemForaMar('')    
        setCustoMar('')

        setPontaAbr('')
        setForaAbr('')
        setDemAbr('')
        setDemForaAbr('')
        setCustoAbr('')

        setPontaMai('')
        setForaMai('')
        setDemMai('')
        setDemForaMai('')
        setCustoMai('')

        setPontaJun('')
        setForaJun('')
        setDemJun('')
        setDemForaJun('')
        setCustoJun('')

        setPontaJul('')
        setForaJul('')
        setDemJul('')
        setDemForaJul('')
        setCustoJul('')

        setPontaAgo('')
        setForaAgo('')
        setDemAgo('')
        setDemForaAgo('')
        setCustoAgo('')

        setPontaSet('')
        setForaSet('')
        setDemSet('')
        setDemForaSet('')
        setCustoSet('')

        setPontaOut('')
        setForaOut('')
        setDemOut('')
        setDemForaOut('')
        setCustoOut('')

        setPontaNov('')
        setForaNov('')
        setDemNov('')
        setDemForaNov('')
        setCustoNov('')

        setPontaDez('')
        setForaDez('')
        setDemDez('')
        setDemForaDez('')
        setCustoDez('')

        setPercDescontoTSUD('')
        setPercRenovavel('')


    }


    useEffect(() => {

        setModalidadeTariafariaLista(listaMod.map((x) =>
        
            <option value={x}>{x}</option>
        ))


    }, [listaMod])



    useEffect(() => {

        populaModalidadeTarifaria()

    }, [subgrupo])


    useEffect(() => {

        populaSubgrupo()

    }, [ambienteContratacao])


    useEffect(() => {

        setSubGrupoLista(lista.map((x) => 

            <option value={x}>{x}</option>

        ))


    }, [lista])




    useEffect(() => {

        limpaCampos()
        carregaConcessionarias()
        consultaDadosCompradaDet()
        consultaDadosCompradaConsumo()
        consultaDadosCompradaCusto()
        consultaDadosCompradaDemanda()


    }, [energiaEletricaComprada_id])


    const handleChange = (e) => {
        e.preventDefault();
    }

    return (

        <div>

            <div className="modal fade" id="modalEnergiaEletricaComprada" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Energia Elétrica Comprada</h1>
                            </div>
                            <div className="modal-body">


                                <div className="row">
                                    

                                <div className="col-md-6" >
                                    <div class="form-group" >
                                        
                                        <label className="control-label">Descrição da Fatura</label>
                                        <input type="text" className="form-control"  value={descricaoFatura} onChange={event => setDescricaoFatura(event.target.value)} style={{ textTransform: 'uppercase'}} />
                                            
                                            
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                        
                                        
                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Concessionária *
                                                <div class="tooltip">
                                                selecione a concessionária ou permissionária a qual está conectado.
                                                </div>
                                            </span>

                                        </label>



                                        <select className='form-control' value={concessionaria} onChange={event => setConcessionaria(event.target.value)}>
                                            
                                            <option value="">[Selecione]</option>
                                            {resultadoConcessionarias}

                                        </select>
                                            
                                    </div>
                                </div>

                                <div className="col-md-4" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Ambiente de Contratação *</label>
                                        <select class="form-control" value={ambienteContratacao} onChange={event => setAmbienteContratacao(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Regulado">Regulado</option>
                                            <option value="Livre">Livre</option>
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Subgrupo *</label>
                                        <select class="form-control" value={subgrupo} onChange={event => setSubGrupo(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            {subgrupoLista}
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Modalidade Tarif&aacute;ria *</label>
                                        <select class="form-control" value={modalidadeTarifaria} onChange={event => setModalidadeTarifaria(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            {modalidadeTarifariaLista}
                                        </select>
                                            
                                    </div>
                                </div>

                                <div className="col-md-4" style={{ display: ambienteContratacao == 'Livre' ? 'table-row' : 'none'}}>
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Tipo de consumidor *</label>
                                        <select class="form-control" value={tipoConsumidor} onChange={event => setTipoConsumidor(event.target.value)}>
                                        <option value="">[Selecione]</option>
                                        <option value="Livre">Livre</option>
                                        <option value="Especial">Especial</option>
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-4" style={{ display: ambienteContratacao == 'Livre' ? 'table-row' : 'none'}}>
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">

                                            <span class="wrapper2">
                                                % de desconto na TUSD/TUST
                                                <div class="tooltip">
                                                digite o percentual de desconto na TUSD/TUST presente na compra de energia incentivada conforme Lei nº 9.427.
                                                </div>
                                            </span>

                                        </label>

                                        <input class="form-control" value={percDescontoTSUD} onChange={event => setPercDescontoTSUD(event.target.value)}
                                        onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                        
                                        />                                           
                                            
                                    </div>
                                </div>
                                <div className="col-md-4" style={{ display: ambienteContratacao == 'Livre' ? 'table-row' : 'none'}}>
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">

                                            <span class="wrapper2">
                                                % de energia renovável
                                                <div class="tooltip">
                                                digite o percentual da energia comprada proveniente de fontes renováveis tais como hidráulica, eólica, solar, biomassa, biogás, biocombustíveis.
                                                </div>
                                            </span>

                                        </label>
                                        
                                        <input class="form-control" value={percRenovavel} onChange={event => setPercRenovavel(event.target.value)} 
                                        onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                        
                                        
                                        />                                           
                                            
                                    </div>
                                </div>

                            




                                </div>

                                <br/>
                                <div className='row'>

                                    <div className="col-md-12" >

                                        
                                        <ul className="nav nav-tabs">
                                                <li className="active"><a href="#tabEC1" data-toggle="tab">Consumo Mensal (kWh)</a></li>
                                                <li><a href="#tabEC2" data-toggle="tab">Demanda Máxima (kW)</a></li>
                                                <li><a href="#tabEC3" data-toggle="tab">Custo Total (R$)</a></li>
                                                
                                        </ul>

                                        <div className="tab-content">
                                            <div className="tab-pane fade in active" id="tabEC1">
                                                <div className="panel-body">


                                                    <table width="100%" className="table table-bordered table-striped table-hover">

                                                        <thead>
                                                            <tr>
                                                                <th style={{backgroundColor: '#e6f7ec'}}>
                                                                    <center>
                                                                    Mês
                                                                    </center>

                                                                </th>
                                                                <th style={{backgroundColor: '#e6f7ec'}}>

                                                                    Ponta/Único

                                                                </th>
                                                                <th style={{backgroundColor: '#e6f7ec'}}>

                                                                    Fora de Ponta

                                                                </th>
                                                                

                                                            </tr>

                                                        </thead>
                                                        <tbody>

                                                        <tr>
                                                    
                                                            <td>
                                                                <center>
                                                                Janeiro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaJan} onChange={event => setPontaJan(event.target.value)} 
                                                                
                                                                />
                                                                
                                                            </td>
                                                            <td>
                                                            
                                                                <CurrencyInput className='form-control' value={foraJan} onChange={event => setForaJan(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                                
                                                                
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Fevereiro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaFev} onChange={event => setPontaFev(event.target.value)}
                                                                
                                                                />
                                                            </td>
                                                            <td>
                                                                
                                                                <CurrencyInput className='form-control' value={foraFev} onChange={event => setForaFev(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Março
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaMar} onChange={event => setPontaMar(event.target.value)} 
                                                                                 
                                                                />
                                                            </td>
                                                            <td>
                                                                
                                                                <CurrencyInput className='form-control' value={foraMar} onChange={event => setForaMar(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Abril
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaAbr} onChange={event => setPontaAbr(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={foraAbr} onChange={event => setForaAbr(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Maio
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaMai} onChange={event => setPontaMai(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={foraMai} onChange={event => setForaMai(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                                
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Junho
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaJun} onChange={event => setPontaJun(event.target.value)}
                                                                
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={foraJun} onChange={event => setForaJun(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Julho
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaJul} onChange={event => setPontaJul(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={foraJul} onChange={event => setForaJul(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Agosto
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaAgo} onChange={event => setPontaAgo(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={foraAgo} onChange={event => setForaAgo(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Setembro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaSet} onChange={event => setPontaSet(event.target.value)}
                                                                
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={foraSet} onChange={event => setForaSet(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Outubro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaOut} onChange={event => setPontaOut(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={foraOut} onChange={event => setForaOut(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Novembro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaNov} onChange={event => setPontaNov(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={foraNov} onChange={event => setForaNov(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Dezembro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={pontaDez} onChange={event => setPontaDez(event.target.value)}
                                                                
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={foraDez} onChange={event => setForaDez(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        </tbody>
                                                    </table>

                                                </div>

                                            </div>
                                            <div className="tab-pane fade in" id="tabEC2">
                                                <div className="panel-body">



                                                    <table width="100%" className="table table-bordered table-striped table-hover">

                                                        <thead>
                                                            <tr>
                                                                <th style={{backgroundColor: '#e6f7ec'}}>
                                                                    <center>
                                                                    Posto Tarifário
                                                                    </center>

                                                                </th>
                                                                <th style={{backgroundColor: '#e6f7ec'}}>

                                                                    Ponta/Único

                                                                </th>
                                                                <th style={{backgroundColor: '#e6f7ec'}}>

                                                                    Fora de Ponta

                                                                </th>
                                                                

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                    
                                                            <td>
                                                                <center>
                                                                Janeiro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demJan} onChange={event => setDemJan(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                                
                                                            </td>
                                                            <td>
                                                            
                                                                <CurrencyInput className='form-control' value={demForaJan} onChange={event => setDemForaJan(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                                
                                                                
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Fevereiro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demFev} onChange={event => setDemFev(event.target.value)}
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                                
                                                            </td>
                                                            <td>
                                                            
                                                                <CurrencyInput className='form-control' value={demForaFev} onChange={event => setDemForaFev(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                                
                                                                
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Março
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demMar} onChange={event => setDemMar(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demForaMar} onChange={event => setDemForaMar(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Abril
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demAbr} onChange={event => setDemAbr(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demForaAbr} onChange={event => setDemForaAbr(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Maio
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demMai} onChange={event => setDemMai(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demForaMai} onChange={event => setDemForaMai(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Junho
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demJun} onChange={event => setDemJun(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demForaJun} onChange={event => setDemForaJun(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Julho
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demJul} onChange={event => setDemJul(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demForaJul} onChange={event => setDemForaJul(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Agosto
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demAgo} onChange={event => setDemAgo(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demForaAgo} onChange={event => setDemForaAgo(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Setembro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demSet} onChange={event => setDemSet(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demForaSet} onChange={event => setDemForaSet(event.target.value)} 
                                                              
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Outubro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demOut} onChange={event => setDemOut(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demForaOut} onChange={event => setDemForaOut(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Novembro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demNov} onChange={event => setDemNov(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demForaNov} onChange={event => setDemForaNov(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Dezembro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demDez} onChange={event => setDemDez(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' ? true : false }
                                                                />
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={demForaDez} onChange={event => setDemForaDez(event.target.value)} 
                                                                
                                                                disabled={ modalidadeTarifaria == 'Convencional Monômia' || modalidadeTarifaria == 'Horária Branca' || modalidadeTarifaria == 'Verde' ? true : false }
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        </tbody>
                                                    </table>

                                                    

                                                </div>

                                            </div>
                                            <div className="tab-pane fade in" id="tabEC3">
                                                <div className="panel-body">


                                                    <table width="100%" className="table table-bordered table-striped table-hover">

                                                        <thead>
                                                            <tr>
                                                                <th style={{backgroundColor: '#e6f7ec'}}>
                                                                    <center>
                                                                    Posto Tarifário
                                                                    </center>

                                                                </th>
                                                                <th style={{backgroundColor: '#e6f7ec'}}>

                                                                    R$

                                                                </th>
                                                                
                                                                

                                                            </tr>

                                                        </thead>
                                                        
                                                        <tbody>

                                                        <tr>
                                                    
                                                            <td>
                                                                <center>
                                                                Janeiro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoJan} onChange={event => setCustoJan(event.target.value)} 
                                                            
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Fevereiro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoFev} onChange={event => setCustoFev(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                        
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Março
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoMar} onChange={event => setCustoMar(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                        
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Abril
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoAbr} onChange={event => setCustoAbr(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Maio
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoMai} onChange={event => setCustoMai(event.target.value)}
                                                                
                                                                />
                                                            </td>
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Junho
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoJun} onChange={event => setCustoJun(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                        
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Julho
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoJul} onChange={event => setCustoJul(event.target.value)} 
                                                                
                                                                onCut={handleChange}
                                                                onCopy={handleChange}
                                                                onPaste={handleChange}
                                                                />
                                                            </td>
                                                            
                                                        
                                                        </tr>

                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Agosto
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoAgo} onChange={event => setCustoAgo(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Setembro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoSet} onChange={event => setCustoSet(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Outubro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoOut} onChange={event => setCustoOut(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Novembro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoNov} onChange={event => setCustoNov(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            
                                                        
                                                        </tr>
                                                        <tr>
                                                        
                                                            <td>
                                                                <center>
                                                                Dezembro
                                                                </center>
                                                            </td>
                                                            <td>
                                                                <CurrencyInput className='form-control' value={custoDez} onChange={event => setCustoDez(event.target.value)} 
                                                                
                                                                />
                                                            </td>
                                                            
                                                        
                                                        </tr>

                                                        </tbody>
                                                    
                                                    </table>

                                                    

                                                </div>

                                            </div>

                                        </div>
                                        
                                        

                                    </div>

                                </div>
                                    

                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-danger" onClick={() => apagaEnergiaComprada()} style={{ display: energiaEletricaComprada_id ? 'table-row' : 'none'}} >Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal